import { getSlider } from "simple-slider";
import domready from "domready";
import { runIfDev } from "../utils";

domready(() => {
	const carousel = document.querySelector('*[data-simple-slider]');
	if (!carousel)
		return;

	const dots = document.querySelectorAll('.slide-indicator > span');
	const mobileCaptions = document.querySelectorAll('.image-carousel-wrapper .mobile-captions .caption');

	const slider = getSlider({
		container: carousel,
		delay: 7,
		paused: false,
		prop: 'opacity',
		unit: '',
		init: 0,
		show: 1,
		end: 0,
		onChange: (_, curr) => {
			//Slidern börjar inte på första, utan på sista, men det vill vi inte ska synas
			//därför får vi transponera lite...
			const itemIndex = (curr + 1) % dots.length;
			dots.forEach(x => x.classList.remove('active'));
			dots[itemIndex].classList.add('active');

			mobileCaptions.forEach(x => x.classList.remove('active'));
			mobileCaptions[curr].classList.add('active');
		}
	});

	slider.reverse();

	const prev = document.querySelector('.slide-prev');
	if (prev)
		prev.addEventListener('click', () => { slider.prev(); slider.pause(); });
	const next = document.querySelector('.slide-next');
	if (next)
		next.addEventListener('click', () => { slider.next(); slider.pause(); });

	runIfDev(() => {
		window["slider"] = slider;
	});
});
